import { Link } from 'react-router-dom'
import { Alert, Button, Group, Paper, Stack, Table, Text, Title } from '@mantine/core'
import { can } from '@racedash/shared'
import { useShell } from '../AppShell'
import { useDashboards } from '../dashboards/useDashboards'
import { restoreDashboard } from '../dashboards/api'
import { relativeTime } from '../lib/time'
import OrgNav from '../components/OrgNav'

export default function Trash() {
  const { user, currentOrg, role } = useShell()
  const { dashboards, error } = useDashboards(currentOrg?.id, user.uid, true)

  if (!currentOrg) return <Text c="dimmed">Organisation not found.</Text>

  if (!can(role, 'dashboard.restore')) {
    return (
      <Stack gap="xs">
        <Title order={1} size="h2">
          Deleted dashboards
        </Title>
        <Text c="dimmed">You need editor access to restore dashboards.</Text>
      </Stack>
    )
  }

  return (
    <Stack gap="lg">
      <Group justify="space-between" align="flex-start">
        <div>
          <Title order={1} size="h2">
            Deleted dashboards
          </Title>
          <Text c="dimmed" size="sm">
            Nothing is ever hard-deleted from the app, so anything here can come back.
          </Text>
        </div>
        <Button component={Link} to={`/o/${currentOrg.id}`} variant="default">
          Back
        </Button>
      </Group>

      <OrgNav orgId={currentOrg.id} role={role} />

      {error && <Alert color="red">{error}</Alert>}
      {!dashboards && !error && <Text c="dimmed">Loading…</Text>}

      {dashboards?.length === 0 && (
        <Paper withBorder p="xl">
          <Text c="dimmed" ta="center">
            Nothing deleted.
          </Text>
        </Paper>
      )}

      {dashboards && dashboards.length > 0 && (
        <Paper withBorder>
          <Table highlightOnHover verticalSpacing="xs" horizontalSpacing="sm">
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Dashboard</Table.Th>
                <Table.Th w={180}>Deleted</Table.Th>
                <Table.Th w={110} />
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {dashboards.map((d) => (
                <Table.Tr key={d.id}>
                  <Table.Td>
                    <Text size="sm" c="dimmed">
                      {d.name}
                    </Text>
                  </Table.Td>
                  <Table.Td>
                    <Text size="sm" c="dimmed">
                      {relativeTime(d.deletedAt)}
                    </Text>
                  </Table.Td>
                  <Table.Td align="right">
                    <Button
                      variant="subtle"
                      size="compact-sm"
                      onClick={() => void restoreDashboard(d.id)}
                    >
                      Restore
                    </Button>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Paper>
      )}
    </Stack>
  )
}
